import React,{useState} from 'react'

const SchemeDiversityDefitions = () => {
   const [showPopup, setShowPopup] = useState(false);
  
    const definitions = [
       {
        title: "Scheme Diversity Table",
        visual: "Table",
        description: "A table showing the schemes delivered in the project, with state-wise delivery percentages. It also displays the benefit value per scheme and the total benefit value unlocked."
      },
      {
        title: "Scheme vs Document Ratio",
        visual: "Pie Chart",
        description: "A pie chart showing the count and percentage of schemes vs. documents processed in the project."
      },
      {
        title: "Scheme Ratio Overview",
        visual: "Table",
        description: "Table displays the number of unique citizens by service profile type, such as Schemes, DFL, and YC, and combinations of each."
      }
      ,
      {
        title: "Citizen Service Statistics",
        visual: "Table",
        description: "Shows the number of unique citizens by state, including how many have accessed 3 or more and 4 or more services"
      }
  ];
  
    return (
      <div className="relative">
        <button
  onClick={() => setShowPopup(true)}
  className="ml-3 inline-flex items-center px-3 py-1.5 rounded-md bg-blue-50 text-blue-700 border border-blue-200 
             hover:bg-blue-100 hover:border-blue-300 transition-all duration-200 text-sm font-medium shadow-sm"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 mr-2 text-blue-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 18a9 9 0 100-18 9 9 0 000 18z" />
  </svg>
  Click here to see KPI Definitions
</button>
  
        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold text-black ">KPI Definitions</h2>
                  <button 
                    onClick={() => setShowPopup(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200 border border-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-lg font-bold text-gray-700 uppercase tracking-wider border border-gray-300 ">KPI</th>
                        <th className="px-6 py-3 text-left text-lg font-bold text-gray-700 uppercase tracking-wider border border-gray-300">Definition</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {definitions.map((item, index) => (
                        <tr key={index}>
                          <td className="px-3 py-2 whitespace-nowrap border border-gray-300">
                            <div className="font-bold text-gray-900 text-left text-sm ">{item.title}</div>
                            {item.visual && (
                              <div className="text-sm text-blue-600 mt-1">{item.visual}</div>
                            )}
                          </td>
                          <td className="px-3 py-2 border border-gray-300">
                            <div className="text-sm text-gray-900 text-left">{item.description}</div>
                            {item.bullets && (
                              <div className="mt-2">
                                <span className="font-bold text-sm text-black">Details:</span>
                                <ul className="list-disc list-inside text-sm text-gray-600 font-bold text-left">
                                  {item.bullets.map((bullet, i) => (
                                    <li key={i} className='mb-2'>{bullet}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setShowPopup(false)}
                    className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
  )
}

export default SchemeDiversityDefitions
